// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"334":"0f35748f","910":"bf59cef4"}[chunkId] + ".css";
};